document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".shopify-section--ingredient-list")
    .forEach((ingredientListSection) => {
      ingredientListSection.addEventListener("click", (event) => {
        const eventPath = event.composedPath
          ? event.composedPath().slice(0, -2)
          : [];

        for (const element of eventPath) {
          const clickAction = element.getAttribute("data-click-action");
          if (!clickAction) continue;

          if (clickAction === "scroll-to-ingredients-accordion") {
            const ingredientAccordion = document.querySelector(
              "#ingredients-accordion",
            );
            if (!ingredientAccordion) continue;

            console.log(ingredientAccordion);

            ingredientAccordion.parentElement.setAttribute("data-active", "");

            ingredientAccordion.scrollIntoView({ behavior: "smooth" });
            break;
          }
        }
      });
    });
});
